var r = {
  userInformation: null,
  orderableProducts: [],
  nextDailymedBox: null,
  healthQuestionnaireLastUpdate: null,
  intakePlans: {
    0: [],
    1: [],
    2: []
  },
  prescriptions: [],
  prescriptionRequests: [],
  nextOpenOrder: null,
  promotion: null,
  nextPlannedOrderDate: null,
  isLoading: !1,
  isInitialized: !1,
  isOrderCardReady: !1,
  isActionCardReady: !1
}, t = (e) => ({
  setDashboardLoading: (a) => e((d) => ({ dashboardData: {
    ...d.dashboardData,
    isLoading: a
  } })),
  updateDashboardData: (a) => e((d) => ({ dashboardData: {
    ...d.dashboardData,
    ...a
  } })),
  completeDashboardFetch: () => e((a) => ({ dashboardData: {
    ...a.dashboardData,
    isLoading: !1,
    isInitialized: !0
  } })),
  resetDashboardData: () => e({ dashboardData: r })
});
export {
  t as createDashboardDataActions,
  r as initialDashboardDataState
};

//# sourceMappingURL=dashboard.action.js.map